import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, finalize, mergeMap, retryWhen, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class RetryInterceptor implements HttpInterceptor {

  constructor(private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      retryWhen(errors => {
        let retryCount = 0;
        return errors.pipe(
          mergeMap(error => {
            if (retryCount < 5 && error.status === 0) {
              retryCount++;
              return this.delayRetry();
            }
            return throwError(error);
          }),
          finalize(() => {
            if (retryCount >= 5) {
              if (environment.redirectOnServerError)
                this.router.navigate(['/authentication/maintenance']);
            }
          })
        );
      })
    );
  }

  private delayRetry(): Observable<any> {
    return new Observable(observer => {
      const retryDelay = 500;
      setTimeout(() => {
        observer.next();
        observer.complete();
      }, retryDelay);
    });
  }
}
